import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { CheckoutPageContent } from 'client/contents/CheckoutPageContent/CheckoutPageContent'

type TProps = {}

const CheckoutPage: FC<TProps> = () => {
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead />
      <CheckoutPageContent />
    </article>
  )
}

export default CheckoutPage
